import styled from 'styled-components';

export const AddressFields = styled.div`
    display: flex;
    flex-flow: column;
`;

export const AddressFieldsRow = styled.div`
    display: flex;
    margin-bottom: 9px;

    & > * {
        flex: 1;

        &:not(:first-child) {
            margin-left: 10px;
        }

        &:not(:last-child) {
            margin-right: 10px;
        }
    }
`;
